<a
  class="link"
  [class.end]="iconPosition === IconPosition.End"
  [attr.data-e2e]="e2eId"
  [attr.href]="linkUrl"
  [attr.target]="target"
  [rel]="linkRel"
  (click)="linkClicked.emit($event)"
>
  <nibtravel-icon
    *ngIf="icon"
    [icon]="icon"
    [size]="size"
    [spacing]="spacing"
    [state]="state"
  ></nibtravel-icon>
  <span *ngIf="linkText">{{ linkText }}</span>
</a>
